export const buildBounds = <T>(
  rows: T[],
  accessor: (row: T) => number | null,
): { max: number; min: number } => {
  let min = Infinity;
  let max = -Infinity;

  for (const row of rows) {
    const value = accessor(row);
    if (value === null || Number.isNaN(value)) {
      continue;
    }
    if (value < min) {
      min = value;
    }
    if (value > max) {
      max = value;
    }
  }

  // No row had a value — zeroed range rather than the Infinity seeds.
  if (min === Infinity) {
    return { max: 0, min: 0 };
  }

  return { max, min };
};
